<h1 mat-dialog-title>
  Changing renewal date of
  <strong>{{ productName }}</strong>
  for
  <strong>{{ customerName }}</strong>
</h1>
<form (ngSubmit)="submit()" [formGroup]="formGroup">
  <div mat-dialog-content>
    <p>
      The subscription's next renewal will occur on
      <strong>{{ nextRenewal | date: 'mediumDate' }} UTC</strong>.
    </p>
    <p>
      Changing the renewal date will
      <strong>NOT</strong>
      automatically prorate the subscription. Any required billing adjustments must be made manually.
    </p>
    <mat-form-field appearance="outline">
      <input
        matInput
        readonly
        [matDatepicker]="renewalPicker"
        placeholder="Renewal Date"
        formControlName="renewalDate"
        required
      />
      <mat-datepicker-toggle matSuffix [for]="renewalPicker"></mat-datepicker-toggle>
      <mat-datepicker #renewalPicker></mat-datepicker>
      <mat-error *ngIf="formGroup.get('renewalDate').hasError('required')"> Renewal date is required </mat-error>
    </mat-form-field>
  </div>
  <mat-dialog-actions class="dialog-actions" align="end">
    <button mat-button type="button" mat-dialog-close class="left-action-button">Cancel</button>
    <button
      type="submit"
      mat-raised-button
      color="primary"
      [disabled]="formGroup.invalid || (loading$$ | async) === true"
    >
      <div class="loading-button">
        <ng-container *ngIf="(loading$$ | async) !== true; else loadingSpinner">
          <mat-icon icon>done</mat-icon>
        </ng-container>
        <span>Submit</span>
      </div>
    </button>
  </mat-dialog-actions>
</form>

<ng-template #loadingSpinner>
  <mat-progress-spinner [diameter]="24" mode="indeterminate"></mat-progress-spinner>
</ng-template>
